import { FinancialPeriodPreparationMethod } from "@inrev/common";
import type { FC } from "react";
import { Tag } from "../Tag";

export type PeriodPreparationMethodTagProps = {
	method: FinancialPeriodPreparationMethod;
	label?: string;
	className?: string;
};

export const PeriodPreparationMethodTag: FC<PeriodPreparationMethodTagProps> = ({
	method,
	label,
	className,
}) => {
	const displayLabel = label?.trim() ? label : FinancialPeriodPreparationMethod.displayName(method);
	return (
		<Tag border oval className={className}>
			{displayLabel}
		</Tag>
	);
};
